import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { BreadcrumbItem } from '../../../app.routes-config';
import { LocalizedLinkPipe } from '../../../pipes/localized-link.pipe';

@Component({
  imports: [RouterLink, TranslatePipe, LocalizedLinkPipe],
  selector: 'app-breadcrumb',
  standalone: true,
  styleUrl: './breadcrumb.scss',
  templateUrl: './breadcrumb.html',
})
export class Breadcrumb {
  @Input({ required: true }) items!: BreadcrumbItem[];
}
